declare global {
    interface Window {
        dojoConfig: {
            isDebug: boolean;
            isQA: boolean;
        };
    }
}
/**
 * This is assuming we're still using dojo with `dojoConfig` defined in the global scope, 
 * located in [_AppShell.cshtml](https://dev.azure.com/Ceridian/Sharptop/_git/dayforce?path=/UI/Framework/Views/_AppShell.cshtml&version=GBmaster). 
 * Update when we migrate away from hosting these info in `dojoConfig`
 */
export const DojoConfig = {
    isDebug: true,
    isQA: false,
};

if (window && window.dojoConfig) {
    const { isDebug, isQA } = window.dojoConfig;
    DojoConfig.isDebug = isDebug;
    DojoConfig.isQA = isQA;
}

export default DojoConfig;
